import { render } from "./OpeningsList.vue?vue&type=template&id=4946dbda&scoped=true"
import script from "./OpeningsList.vue?vue&type=script&lang=js"
export * from "./OpeningsList.vue?vue&type=script&lang=js"

import "./OpeningsList.vue?vue&type=style&index=0&id=4946dbda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4946dbda"],['__file',"src/views/OpeningsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4946dbda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4946dbda', __exports__)) {
    api.reload('4946dbda', __exports__)
  }
  
  module.hot.accept("./OpeningsList.vue?vue&type=template&id=4946dbda&scoped=true", () => {
    api.rerender('4946dbda', render)
  })

}


export default __exports__